
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"font-family":"sans-serif"}},[_c('path',{attrs:{"d":"M9.017.013C4.051.013.013 4.051.013 9.017c0 4.968 4.038 9.004 9.004 9.004 4.968 0 9.004-4.036 9.004-9.004 0-4.966-4.036-9.004-9.004-9.004zm0 1.162a7.832 7.832 0 017.842 7.842 7.832 7.832 0 01-7.842 7.842 7.832 7.832 0 01-7.842-7.842 7.832 7.832 0 017.842-7.842z","overflow":"visible"}}),_c('path',{attrs:{"d":"M5.509 4.661a.871.871 0 00-.593.255.871.871 0 000 1.232l2.87 2.87-2.87 2.87a.871.871 0 000 1.232.871.871 0 001.232 0l2.87-2.87 2.87 2.87a.871.871 0 001.232 0 .871.871 0 000-1.232l-2.87-2.87 2.87-2.87a.871.871 0 000-1.232.871.871 0 00-.64-.255.871.871 0 00-.592.255l-2.87 2.87-2.87-2.87a.871.871 0 00-.64-.255z","overflow":"visible"}})])])
          )
        }
      }
    